import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../api/api";
import PostApi from "../../api/PostApi";
import { loadTopPostsSuccess, loadTopPostsFailed } from "./actions";

export function* handleLoadTopPostsRequests() {
  const loadTopPostsRequests = PostApi.getLoadTopPostsUrl(3);
  try {
    const { data: posts } = yield call(api.get, loadTopPostsRequests.url);
    yield put(loadTopPostsSuccess(posts));
  } catch (error) {
    yield put(loadTopPostsFailed(error));
  }
}

export function* watchLoadTopPostsRequests(props) {
  yield takeLatest("LOAD_TOP_POSTS_REQUEST", handleLoadTopPostsRequests);
}



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/sagas.js